import { TDynamicFieldProps } from '@/types/TSmartCRM';
import { EFieldType } from 'src/enums/ESmartCRM';
import { TextRenderer } from './renderers/TextRenderer';
import { SelectRenderer } from './renderers/SelectRenderer';
import { DateRenderer } from './renderers/DateRenderer';
import { BooleanRenderer } from './renderers/BooleanRenderer';
import { NumberRenderer } from './renderers/NumberRenderer';
import { ArrayRenderer } from './renderers/ArrayRenderer';

const FIELD_RENDERERS = {
	[EFieldType.TEXT]: TextRenderer,
	[EFieldType.SELECT]: SelectRenderer,
	[EFieldType.DATE]: DateRenderer,
	[EFieldType.BOOLEAN]: BooleanRenderer,
	[EFieldType.NUMBER]: NumberRenderer,
	[EFieldType.MULTISELECT]: ArrayRenderer,
};

export const DynamicField = (props: TDynamicFieldProps) => {
	const { field } = props;
	const Renderer = FIELD_RENDERERS[field.fieldType];

	if (!Renderer) {
		return <span>Unsupported field type: {field.fieldType}</span>;
	}

	return <Renderer {...props} />;
};
